import axios from "axios";
import { saveAs } from "file-saver";
import { useFormik } from 'formik';
import $ from "jquery";
import JsPDF from "jspdf";
import JSZip from 'jszip';
import moment from 'moment';
import Papa from "papaparse";
import React,{ useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataTable from "react-data-table-component";
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Select from "react-select";
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import * as Yup from 'yup';
import SkeletonTicketList from '../../../../loaders/SkeletonTicketList';
import { addUpdateDeleteSignature, addUpdateFeedback, DeleteAssessmentSubmissionUpload, deleteFeedbackFiles, generateFeedbackStudent, GetAssessmentSubmissionUpload, GetStudentSubmissionDetails, updateAdditionalFeedBack, updateAssessmentMarkingQuestionScore, UpdateSubmission } from '../../../../services/CourseService';
import { LongAndShortAns } from '../../../../services/SmartAssessmentService';
import { twoDecimalRound } from '../../../../utils/commonFunction';
import { RenderQuestionLevel, RenderQuestionType, RenderResult } from '../../../../utils/CommonGroupingItem';
import { RenderQuizResult } from '../../../../utils/CommonStatusItems';
import { AWS_BASE_URL, downloadURL, IMAGE_URL, STUDENT_FILE_DOWNLOAD } from '../../../../utils/Constants';
import PermissionsGate from "../../../../utils/permissionGate";
import AssessmentDetails from '../../../common/AssessmentDetails';
import DataTableComponentFrontPagination from '../../../common/DataTableComponentFrontPagination';
import DigitalSignatureComponent from '../../../common/DigitalSignatureComponent';
import { formatFileSize, GroupHeader, GroupStyle, isBlockedNumericKey } from '../../../common/Helper';
import { RenderAttachList } from '../../../common/RenderAttachListFeed';
import Tablefilter from '../../../common/Tablefilter';
import { TrimText } from '../../../common/TrimText';
import { handleUploadToS3BucketUrl } from '../../../common/uploadTOS3BucketUrl';
import DownloadModalComponent from './DownloadModalComponent';
import ExpandableText from './ExpandableText';
import SubmissionModal from './SubmissionModal';

function SubmissionAndResultForm(props) {
  const { id, subId, subSubId, attemptId } = useParams();

  const [search, setSearch] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [assDetails, setAssDetails] = useState([]);
  const [questionLoading, setQuestionLoading] = useState(false)
  const [saveLoading, setSaveLoading] = useState(false);
  const [setToFinalLoading, setSetToFinalLoading] = useState(false);
  const [generateEvaluationLoading, setGenerateEvaluationLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterData, setFilterData] = useState({ type: [], level: [] });
  const [type, setType] = useState({ arr: [], checkObj: {} });
  const [level, setLevel] = useState({ arr: [], checkObj: {} });
  const [statusArr, setStatusArr] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({
    hybrid: true,
    smart: false
  });
  const [feedbackFiles, setFeedbackFiles] = useState("");
  const [feedbackFileName, setFeedbackFileName] = useState("");
  const [lecturerFeedbackFiles, setLecturerFeedbackFiles] = useState([]);
  const [backupFeedbackFiles, setBackupFeedbackFiles] = useState({});
  const [cDate, setCDate] = useState(null);
  const [ipAddress, setIpAddress] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [isSig, setIsSig] = useState(null);
  const [is_Signature, setIs_Signature] = useState(false)
  const [studentSubmissionDetails, setStudentSubmissionDetails] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [scoreGear, setScoreGear] = useState("");
  const [updatedValue, setUpdatedValue] = useState("");
  const [gearLoading, setGearLoading] = useState(false);
  const [isCancel, setIsCancel] = useState(false)
  const [allQuestionsMarked, setAllQuestionsMarked] = useState(false);
  const [evaluationGenerated, setEvaluationGenerated] = useState({
    fileName: "",
    fileSize: ""
  });
  const [selectedStudentDetails, setSelectedStudentDetails] = useState({})
  const [fileName, setFileName] = useState();
  const [refreshQuestiionData, setRefreshQuestiionData] = useState(false)
  const [file, setFile] = useState();
  const [disabled, setDisabled] = useState(false);
  const [scoreChanged, setScoreChanged] = useState(false);
  const [statusSelected, setStatusSelected] = useState();
  const [submissionFiles, setSubmissionFiles] = useState([]);
  const [studentDetails, setStudentDetails] = useState({})
  const [refreshStudentList, setRefreshStudentList] = useState(false)
  const [assessmentData, setAssessmentData] = useState(null);
  const [FinalLoadedData, setFinalLoadedData] = useState(0);
  const [finalTotal, setFinalTotal] = useState(0);
  const downloadRef = useRef(null);
  const [space, setSpace] = useState("evidence");
  const history = useHistory();
  const signaturePadRef = useRef(null);
  const fileInputRef = useRef(null);
  const attachmentRef= useRef(null)
  const [adminData, setAdminData] = useState({})
  const [uploadFeedBackLoading, setUploadFeedBackLoading] = useState(false);
  const [uploadInputKey, setUploadInputKey] = useState(Date.now()); 
  const [assessmentName , setAssessmentName] = useState("")
  const [feedbackUploadedFrom, setfeedbackUploadedFrom] = useState(null)
  const [attachmentSearch, setAttachmentSearch]=useState("")
  const [reload, setReload]= useState(Date.now())
  const [deletedSubmissionFile, setDeletedSubmissionFile] = useState({ file: {}, deleted: false });
  const [getSubmissionData, setGetSubmissionData]= useState([])
  

  // Get user permissions from Redux store
  const givenPermissions = useSelector((state) => state.givenPermission);
  
  // Helper function to check if user has permission
  const hasCastEditPermission = () => {
    const permissions = [];
    Object.keys(givenPermissions).forEach((key) => {
      permissions.push(givenPermissions[key]);
    });
    return permissions.includes(studentSubmissionDetails?.isHybrid ? "cassgradeassedit" : "overidersmart");
  };

  const hasUploadNewFilePermission = () => {
    const permissions = [];
    Object.keys(givenPermissions).forEach((key) => {
      permissions.push(givenPermissions[key]);
    });
    return permissions.includes('gamodifysub');
  };

  const dataToRender = () => {
    let updatedData = [];
    let allData = quizQuestions;
    if (search.length) {
      let tempname = allData.filter((item) => {
        let includes = item.question_name && item.question_name.toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempname];
      let unique = [...new Set(data)];
      updatedData = unique;
    } else {
      updatedData = allData;
    }
    if (type.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = type.arr.find(function (post, index) {
          if (post === item.questionType ? item.questionType : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }
    if (level.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = level.arr.find(function (post, index) {
          if (post.toString() === item.level_name ? item.level_name.toString() : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }
    if (search.length || type.length || level.arr) {
      return updatedData;
    } else {
      return quizQuestions;
    }
  };

  const groups = [
    {
      id: 'smart',
      name: 'Smart Questions',
      icon: 'spell-check',
      filter: (question) => !['Evidence Only', 'Document Upload', 'Long Answer'].includes(question.questionType)
    },
    {
      id: 'hybrid',
      name: 'Hybrid Questions',
      icon: 'shapes',
      filter: (question) => ['Evidence Only', 'Document Upload', 'Long Answer'].includes(question.questionType)
    }
  ];

  // Create grouped data
  const groupedQuestions = useMemo(() => {
    const updatedQuizQuestions = dataToRender();

    // Add styling to questions
    const styledQuestions = updatedQuizQuestions.map(question => ({
      ...question,
      className: ((question.questionType !== "Document Upload" && question.questionType !== "Long Answer" && question.questionType !== "Evidence Only") ? (question.finalResult && question.finalResult >= 0) : (question.showValue == 1 && question.finalResult && question.finalResult >= 0)) ? 'white-bg' : 'red-gradian-bg'
    }));

    // Create grouped array with headers and filtered questions
    return groups.reduce((acc, group) => {
      // Add group header
      const filteredQuestions = styledQuestions.filter(group.filter);

      if (filteredQuestions.length > 0) {
        acc.push({
          id: `${group.id}-header`,
          isGroupHeader: true,
          group: group
        });
      }

      if (expandedGroups[group.id]) {
        const filteredQuestions = styledQuestions.filter(group.filter);
        acc.push(...filteredQuestions);
      }

      return acc;
    }, []);
  }, [quizQuestions, expandedGroups, search, type, level]);

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const handleScoreUpdate = (e, row) => {

    const newScore = parseFloat(e.target.value);
    const currentScore = row.finalResult ? parseFloat(row.finalResult) : 0;
    let value = e.target.value ? Number(e.target.value) : "a";

    if (row?.showValue == 1 && (newScore == currentScore)) {
      return;
    }

    setGearLoading(true);
    setScoreGear(row.id);
    setUpdatedValue(newScore)

    if (newScore > parseFloat(row.totalScoreIndividual)) {
      setErrorMessage("You can't put mark more then Total mark");
      setGearLoading(false);
      setUpdatedValue(row?.finalResult)
      return;
    } else {
      setErrorMessage("");
    }

    const data = {
      rid: attemptId ? attemptId : studentSubmissionDetails?.attempted_id,
      qid: row.qid.toString(),
      updated_qid: row.id,
      score: value,
      tab: attemptId ? "Attempt" : "Question Feedback",
      intake: id,
    }

    updateAssessmentMarkingQuestionScore(data)
      .then((res) => {
        if (res.status == 200) {
          fetchData("scoreUpdate");
          fetchQuestions("scoreUpdate");
          setScoreChanged(true);
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: "Something went wrong",
          icon: "error"
        })
        console.error(err, "err")
      })
  }

  const EvidenceItem = ({ type, item, hasEvidence }) => {
    const icon = type === 0 ? 'fa-camera' : 'fa-video';
    const label = type === 0 ? 'Photo' : 'Video';

    return (
      <div className="evidence-wrp mr-4">
        <i className={`fas ${hasEvidence ? 'fa-check-circle cat-greenhex' : 'fa-times-circle colorRed'}`} />
        <i className={`fal ${icon}`} />
        <p>{label}</p>
      </div>
    );
  };

  const groupEvidence = (item) => {
    const groupedEvidence = (item?.studentEvidence || []).reduce((acc, evidence) => {
      const type = evidence.evidence_type;
      if (type === 0 || type === 1) {
        acc[type] = [...(acc[type] || []), evidence];
      }
      return acc;
    }, {});

    return [0, 1].map((type, id) => (
      <div key={id}>
        {(type === 0 && item.evidence_photo === 1) ? groupedEvidence[type] && groupedEvidence[type].length > 0 && (
          <EvidenceItem type={type} hasEvidence={true} />
        ) : (type === 1 && item.evidence_video === 1) ? groupedEvidence[type] && groupedEvidence[type].length > 0 && (
          <EvidenceItem type={type} hasEvidence={true} />
        ) : null}

        {(type === 0 && item.evidence_photo === 1) ? !groupedEvidence[type] && <EvidenceItem type={type} hasEvidence={false} /> : (type === 1 && item.evidence_video === 1) ? !groupedEvidence[type] && <EvidenceItem type={type} hasEvidence={false} /> : null}
      </div>
    ));
  };

  const handleDocumentDownload = (submittedFiles) => {
    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    const zip = new JSZip();
    try {
      if (Array.isArray(submittedFiles) && submittedFiles.length) {
        let p = Promise.all(submittedFiles.map(async (item, index) => {
          if (item.docs && item.docs != "" && item.docs != null) {
            const fileName = item.docs.split("/").reverse()[0];
            const fileURL = downloadURL + `${item.docs.includes("s3.af-south-1.amazonaws.com") ? "" : STUDENT_FILE_DOWNLOAD + "/"}${encodeURI(item.docs.replaceAll(
              "/home/myaie/public_html/", "").replace("public/", ""))}`;
            try {
              const getFile = await axios({
                url: fileURL,
                method: 'get',
                responseType: 'blob',
              })
              zip.file(`${fileName}`, getFile.data, { binary: true });
            } catch (errrr) {
              console.error(errrr)
              Swal.close();
              return;
            }

          }
        }))
        p.then(() => {
          zip.generateAsync({ type: 'blob' }).then((content) => {
            saveAs(content, `submitted_file_ques_upload` + ".zip");
          }).catch((err1) => { console.error(err1) })
        }).catch((err) => {
          console.error(err)
        })

      }
    } catch (err) {
      console.error(err)
    } finally {
      Swal.close()
    }
  }

  const questionName = (row) => {
    return (
      <div className='d-flex align-items-center'>
        <div className='mr-4' style={row?.questionType == "Evidence Only" ? { width: 704 } : { width: 400 }}>
          <span
            className="as-text-blue curser feature-name"
            title={row?.question_name}
            data-toggle="modal"
            data-target="#assessment-submission-modal"
            onClick={() => {
              $("#assessment-submission-modal").modal("show");
              setSelectedStudentDetails({...row , studentName: studentDetails?.studentName , assessment_id: subId , uid: subSubId , rid: studentSubmissionDetails?.attempted_id ,total_score: row?.totalScoreIndividual, score: row?.finalResult, is_marked: row?.showValue})
            }}
          >
            <span className="textLimit100">{row?.question_name}</span>
          </span>

          <ExpandableText maxWidth={400} text={row?.questionName} />
        </div>
        {row?.questionType != "Evidence Only" ? <div className='mr-4' style={{ minWidth: 280 }}>
          {((row?.questionType != "Document Upload" && row?.questionType != "Evidence Only" && row?.questionType != "Long Answer") && row?.correctAnswer) ? <>
            <p className='mb-0 as-text-blue' style={{ fontWeight: 600, fontSize: 12 }} title={"Correct Answer"}>
              Correct Answer
            </p>
            <ExpandableText maxWidth={280} text={row?.correctAnswer} />
          </>
            :
            (row?.questionType == "Document Upload" && row?.answerdDocument.length > 0) ?
            <DownloadModalComponent 
              children={
                <p data-toggle="modal" data-target="#downloadSubmission" className="as-text-blue curser" title={"Download Submission"}>
                  Download Submission<span className='ml-2'><i className='fal fa-download' style={{ fontWeight: 300, fontSize: 12 }}></i></span> 
                </p>
              } modalId={'downloadSubmission'} type={'downloadSubmission'} downloadRef={downloadRef} payload={handleDownload(row?.qid, `${studentDetails?.studentName}_${assessmentName}`)} zipName={`${studentDetails?.studentName}_${assessmentName}`}
            />
              : (row?.questionType == "Long Answer" && row?.UserAnswer) ? <>
                <p className='mb-0 as-text-blue' style={{ fontWeight: 600, fontSize: 12 }} title={"Submitted Answer"}>
                  Submitted Answer
                </p>
                <ExpandableText maxWidth={280} text={row?.UserAnswer} />
              </> :
                "-"
          }
        </div> : null}
        <div className='assessment_marking mr-4' style={{ maxWidth: 430 }}>
          {((row?.questionType != "Evidence Only" && row?.questionType != "Document Upload" && row?.questionType != "Long Answer") && row?.UserAnswer) ?
            <>
              <p className='mb-0 as-text-blue' style={{ fontWeight: 600, fontSize: 12 }} title={"Submitted Answer"}>
                Submitted Answer
              </p>
              <ExpandableText maxWidth={280} text={row?.UserAnswer} />
            </>
            :
            <div className='evidence-con remove_gap'>
              {(row?.evidence_photo == 1 || row?.evidence_video == 1) ? groupEvidence(row || []) : row?.evidence_lecturer_observation ? null : "-"}
              {row?.evidence_lecturer_observation != null && row?.evidence_lecturer_observation != undefined && row?.evidence_lecturer_observation == 1 && (
                <div title={"Lecturer Observation"}>
                  <div className='evidence-wrp'>
                    {row?.is_observation == 1 ? <i className="fas fa-check-circle cat-greenhex"></i> : <i className='fas fa-times-circle colorRed'></i>}
                    <i className="fal fa-user-check" />
                    <p>Lecturer Observation</p>
                  </div>
                </div>
              )}
            </div>}
        </div>
      </div>
    )
  }

  const handleDownload = (questionId, fileName, evidence_type) => {
    let payload = {
      assignmentId: subId,
      attempt_id: attemptId,
      student_id: subSubId,
      intake: id
    }
    if (questionId) {
      payload.qid = questionId
    }
    if (evidence_type) {
      payload.evidence_type = evidence_type?.toLowerCase() == "photo" ? 0 : 1
    }
    return payload
  }

  function isMatchingQuestionType(allowedTypes = []) {
    if (!selectedStudentDetails?.questionType) return false;
    const type = selectedStudentDetails.questionType.toLowerCase();
    return allowedTypes.map(t => t.toLowerCase()).includes(type);
  }

  const columns = useMemo(() => [
    {
      name: "Question",
      selector: "Question",
      sortField: "question_name",
      sortable: false,
      cell: (row) => {
        if (row.isGroupHeader) {
          return <GroupHeader
            group={row.group}
            onClick={() => toggleGroup(row.group.id)}
          />;
        }

        return (
          questionName(row)
        );
      },
      width: '100%'
    },
    {
      name: "Type",
      selector: "Type",
      sortField: "questionType",
      sortable: false,
      cell: (row) => {
        if (row.isGroupHeader) return <GroupStyle onClick={() => toggleGroup(row.group.id)} />
        return (
          (row.questionType ? RenderQuestionType(row.questionType.trim()).html : "-")
        )
      },
    },
    {
      name: "Level",
      selector: "level",
      sortField: "level",
      sortable: false,
      cell: (row) => row.isGroupHeader ? <GroupStyle onClick={() => toggleGroup(row.group.id)} /> : (row.level_name ? RenderQuestionLevel(row.level_name).html : "-")
    },
    {
      name: "Marking",
      selector: "marking",
      sortField: "marking",
      sortable: false,
      cell: (row) => row.isGroupHeader ? <GroupStyle onClick={() => toggleGroup(row.group.id)} /> : (!(row?.questionType == "Document Upload" || row?.questionType == "Long Answer" || row?.questionType == "Evidence Only") ? RenderQuizResult("automarked").html : row?.showValue == 1 ? RenderQuizResult("marked").html : RenderQuizResult("notyetmarked").html)
    },
    {
      name: "Score",
      selector: "score",
      cell: (row) => row.isGroupHeader ? <GroupStyle onClick={() => toggleGroup(row.group.id)} /> : (row.questionType != "Document Upload" && row.questionType != "Long Answer" && row.questionType != "Evidence Only") ? (row?.finalResult &&
        (row?.totalScoreIndividual || row?.score) ? <p title={`${twoDecimalRound(row?.finalResult)}/${row?.totalScoreIndividual ? twoDecimalRound(row?.totalScoreIndividual) : twoDecimalRound(row?.score)}`}>{`${twoDecimalRound(row?.finalResult)}/${row?.totalScoreIndividual ?
          twoDecimalRound(row?.totalScoreIndividual) :
          twoDecimalRound(row?.score)}`}</p> : "-")
        : (<div className="input-submission-col resultstatus_flex arrowhide">
          <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
            <input
              className={"form-control" + (errorMessage != "" && scoreGear == row.id ? " is-invalid" : "")}
              type="number"
              max={row.totalScoreIndividual}
              onKeyDown={(e) => {
                // Block +, -, and other non-numeric keys (allow numbers, decimal, backspace, delete, arrows)
                if (isBlockedNumericKey(e.key)) e.preventDefault();
              }}
              defaultValue={scoreGear == row?.id ? updatedValue : (row?.finalResult && row.showValue == 1) ? twoDecimalRound(row?.finalResult) : "-"}
              onBlur={(e) => handleScoreUpdate(e, row)}
            />
          </PermissionsGate>
          <span>{"/" + row.totalScoreIndividual}</span>
          {(gearLoading == true && scoreGear == row.id) ? <i className="fas fa-cog fa-spin"></i> : ""}
        </div>)
    },
    {
      name: "Result",
      selector: "result",
      sortField: "result",
      sortable: false,
      cell: (row) => {
        if (row.isGroupHeader) {
          return <GroupStyle onClick={() => toggleGroup(row.group.id)} />;
        }

        const isSpecialQuestionType = ["Document Upload", "Long Answer", "Evidence Only"].includes(row?.questionType);
        const shouldShowResult = row?.finalResult && (!isSpecialQuestionType || row?.showValue === 1);
        
        if (!shouldShowResult) {
          return "-";
        }

        // Render result based on grading type
        return assDetails.grading_type != 1 
          ? <p title={row?.result || "-"}>{row?.result}</p> 
          : RenderResult(row?.result).html;
      }
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => row.isGroupHeader ? <GroupStyle onClick={() => toggleGroup(row.group.id)}> <i
        className={`fal fa-${expandedGroups[row.group.id] ? 'minus' : 'plus'}-circle questions-group-icon`}
        style={{ color: "#477998" }}
      /> </GroupStyle> : (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
            <div
              className="btn btn-primary rounded-circle cursor-pointer"
              data-toggle="modal"
              data-target="#assessment-submission-modal"
              title="Open"
              onClick={() => {
                $("#assessment-submission-modal").modal("show");
                setSelectedStudentDetails({...row , studentName: studentDetails?.studentName , assessment_id: subId , uid: subSubId , rid: studentSubmissionDetails?.attempted_id , total_score: row?.totalScoreIndividual, score: row?.finalResult, is_marked: row?.showValue})
              }}
            >
              <i className="fal fa-folder-open"></i>
            </div>
          </div>
        </div>
      )
    }
  ], [quizQuestions, expandedGroups, studentSubmissionDetails, gearLoading, scoreGear,assessmentName]);

  const getFileName = (filepath) => {
    let fileName = filepath.substring(filepath.lastIndexOf('/') + 1);
    fileName = fileName.replace(/%20/g, ' '); // Replace URL-encoded spaces with actual spaces
    return fileName;
  }

  const exportData = (fileType, fileName) => {
    try {
      const data = dataToRender();

      const header = ["Question", "Correct Answer", "Submitted Answer", "Type", "Level", "Marking", "Score"];

      Swal.fire({
        title: "File downloading",
        onOpen: function () {
          Swal.showLoading();
        },
      });

      const getEvidenceText = (row) => {
        const evidences = [];
        if (row?.evidence_photo == 1) evidences.push("Photo");
        if (row?.evidence_video == 1) evidences.push("Video");
        if (row?.evidence_lecturer_observation == 1) evidences.push("Lecturer Observation");
        return evidences.length > 0 ? evidences.join(", ") : "-";
      };

      // Helper function to strip HTML tags
      const stripHtml = (html) => {
        if (!html) return "-";
        try {
          const temp = document.createElement("div");
          temp.innerHTML = html;
          return temp.textContent || temp.innerText || "-";
        } catch (error) {
          console.error('Error stripping HTML:', error);
          return String(html || "-");
        }
      };

      let exportData = [];
      groups.forEach(group => {
        const filteredQuestions = data.filter(group.filter);

        if (filteredQuestions.length > 0) {
          exportData.push({
            Question: `${group.name}`,
            "Correct Answer": "",
            "Submitted Answer": "",
            Type: "",
            Level: "",
            Marking: "",
            Score: "",
          });
        }

        filteredQuestions.forEach(row => {
          const rowData = {
            Question: row?.question_name ? row?.question_name : "-",
            "Correct Answer": row?.questionType != "Document Upload" &&
              row?.questionType != "Evidence Only" &&
              row?.questionType != "Long Answer" ?
              stripHtml(row?.correctAnswer || "-") : "-",
            "Submitted Answer": row?.questionType != "Document Upload" &&
              row?.questionType != "Evidence Only" ?
              stripHtml(row?.UserAnswer || "-") : "-",
            Type: row?.questionType ? RenderQuestionType(row?.questionType.trim()).text : "-",
            Level: row?.level_name ? RenderQuestionLevel(row?.level_name).text : "-",
            Marking: (!(row?.questionType == "Document Upload" ||
              row?.questionType == "Long Answer" ||
              row?.questionType == "Evidence Only") ?
              RenderQuizResult("automarked").text :
              row?.showValue == 1 ?
                RenderQuizResult("marked").text :
                RenderQuizResult("notyetmarked").text),
            Score: row?.finalResult && row?.totalScoreIndividual ?
              `${twoDecimalRound(row?.finalResult)}/${row?.totalScoreIndividual ?
                twoDecimalRound(row?.totalScoreIndividual) :
                twoDecimalRound(row?.score)}` : "-",
          };
          exportData.push(rowData);
        });
      });

      if (fileType === "csv") {
        try {
          const csvString = Papa.unparse(exportData, {
            quotes: true,
            quoteChar: '"'
          });

          const BOM = "\uFEFF";
          const blobContent = BOM + csvString;
          const blob = new Blob([blobContent], { type: "text/csv;charset=utf-8" });
          const blobURL = window.URL.createObjectURL(blob);

          const anchor = document.createElement("a");
          anchor.download = `${fileName}.csv`;
          anchor.href = blobURL;
          anchor.click();

          setTimeout(() => {
            URL.revokeObjectURL(blobURL);
          }, 1000);
        } catch (error) {
          console.error('Error in CSV export:', error);
          Swal.fire('Error', 'Failed to export CSV file', 'error');
        }
      } else if (fileType === "xlsx") {
        try {
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.json_to_sheet(exportData, { header });
          XLSX.utils.book_append_sheet(wb, ws, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
        } catch (error) {
          console.error('Error in Excel export:', error);
          Swal.fire('Error', 'Failed to export Excel file', 'error');
        }
      } else if (fileType === "pdf") {
        try {
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: exportData.map(row => [
              row["Question"],
              row["Correct Answer"],
              row["Submitted Answer"],
              row["Type"],
              row["Level"],
              row["Marking"],
              row["Score"]
            ]),
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
        } catch (error) {
          console.error('Error in PDF export:', error);
          Swal.fire('Error', 'Failed to export PDF file', 'error');
        }
      }

      Swal.close();
    } catch (error) {
      console.error('Export error:', error);
      Swal.fire('Error', 'Failed to export file', 'error');
    }
  };

  const handleGenerateEvaluation = () => {
    setGenerateEvaluationLoading(true);

    if (!allQuestionsMarked && (signatureFormik.values?.is_marker_signature_required == 1 && !signatureFormik.values?.lecturer_Signature)) {
      Swal.fire({
        title: "Error",
        text: "Please Mark All Questions and Upload a Signature",
        icon: "error",
        confirmButtonText: "OK"
      });
      setGenerateEvaluationLoading(false);
      return;
    } else if (!allQuestionsMarked) {
      Swal.fire({
        title: "Error",
        text: "Please Mark All Questions",
        icon: "error",
        confirmButtonText: "OK"
      });
      setGenerateEvaluationLoading(false);
      return;
    } else if (signatureFormik.values?.is_marker_signature_required == 1 && !signatureFormik.values?.lecturer_Signature) {
      Swal.fire({
        title: "Error",
        text: "Please Upload a Signature",
        icon: "error",
        confirmButtonText: "OK"
      });
      setGenerateEvaluationLoading(false);
      return;
    }

    const data = {
      assessment_id: parseInt(subId),
      rid: studentSubmissionDetails?.attempted_id,
      uid: parseInt(subSubId),
      isEvidence: 1,
      tab: attemptId ? "Attempt" : "Question Feedback"
    }

    generateFeedbackStudent(data)
      .then(res => {
        setEvaluationGenerated({
          fileName: res?.data?.fileName,
          fileSize: res?.data?.fileSizeInBytes
        })
        setfeedbackUploadedFrom(1)
        Swal.fire({
          title: "Success",
          text: "Evaluation generated successfully",
          icon: "success",
          confirmButtonText: "OK"
        });
      })
      .catch(err => {
        console.error(err);
        Swal.fire({
          title: "Error",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "OK"
        });
      })
      .finally(() => {
        setGenerateEvaluationLoading(false);
      })
  }

  const handleSubmit = (type) => {
    if (studentSubmissionDetails?.is_marker_signature_required == 1){
      if(signatureFormik.values?.lecturer_Signature == "" || signatureFormik.values?.lecturer_Signature == null) {
        signatureFormik.setErrors({
          lecturer_Signature: "Please upload a signature"
        });
        
        // Also set the touched state for the field
        signatureFormik.setTouched({
          lecturer_Signature: true
        }, false);
        return;
      }
    }

    formik.setFieldValue("type", type);
    formik.handleSubmit();
  };

  const handleCancel = () => {
    formik.setFieldValue("feedback", studentSubmissionDetails?.getAdminSignature?.feedback || "");
    formik.setFieldValue("use_generated_feedback", studentSubmissionDetails?.getAdminSignature?.use_generated_feedback || 0);
    signatureFormik.setErrors({
      lecturer_Signature: ""
    });
    
    // Also set the touched state for the field
    signatureFormik.setTouched({
      lecturer_Signature: false
    }, false);
  }

  const signatureFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      lecturer_Signature: studentSubmissionDetails?.getAdminSignature?.signature || "",
      signature_ip: studentSubmissionDetails?.getAdminSignature?.signature_ip || "",
      signature_date: studentSubmissionDetails?.getAdminSignature?.signature_date || "",
      signature_type: studentSubmissionDetails?.getAdminSignature?.signature_type || 0,
      isDeleted: 0,
      is_marker_signature_required: 0,
    },
    onSubmit: async (values) => {
      setSaveLoading(true)
      let newFileURL=`Students/${studentSubmissionDetails?.student_id}_${studentSubmissionDetails?.student_number}_${studentSubmissionDetails?.first_name}_${studentSubmissionDetails?.last_name}_${subId}_${studentSubmissionDetails?.name}/${studentSubmissionDetails?.name}_${studentSubmissionDetails?.student_number}_signature_${moment().unix()}.${values.lecturer_Signature?.name?.split(".").pop()}`
      
      const formData = new FormData();

      if (!values.isDeleted) {

        let awsFileUploadedUrl = [];

        // Define the upload file entry
        awsFileUploadedUrl.push({
          file_name: newFileURL,
          file_type: values.lecturer_Signature.type,
        });

        const resultData = await handleUploadToS3BucketUrl(awsFileUploadedUrl, values.lecturer_Signature);
        if (!resultData) return;

        resultData.forEach((item) => {
          formData.append('signature', item?.path); 
          formData.append('file_size', item.size || 0);
        });

      } else {
        formData.append("signature", values.lecturer_Signature);
      }


      formData.append("assessment_id", subId);
      formData.append("student_id", parseInt(subSubId));
      formData.append("rid", studentSubmissionDetails?.attempted_id);
      formData.append("signature", values.lecturer_Signature);
      formData.append("signature_ip", values.signature_ip);
      formData.append("signature_date", values.signature_date);
      formData.append("signature_type", values.signature_type);
      formData.append("isDeleted", values.isDeleted);
      formData.append("tab", attemptId ? "Attempt" : "Question Feedback");

      addUpdateDeleteSignature(formData)
        .then(res => {
          Swal.fire({
            title: "Success",
            text: `Signature ${values.isDeleted == 1 ? "Deleted" : "Added"} Successfully`,
            icon: "success",
            confirmButtonText: "OK"
          });
        })
        .catch(err => {
          console.error(err);
        }).finally(()=>setSaveLoading(false))
    }
  })

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: {
      feedback: '',
      type: "",
      use_generated_feedback: 0,
      location: "",
    },
    onSubmit: (values) => {
      if (values.type == "setToFinal") {
        setSaveLoading(false);
      } else {
        setSaveLoading(true);
      }

      const formData = new FormData();

      const trimmedValues = Object.fromEntries(
        Object.entries(values).map(([key, value]) => [
          key,
          typeof value === "string" ? value.trim().replace(/ +/g, " ") : value,
        ])
      );

      Object.keys(trimmedValues).forEach((key) => {
        if (key !== 'grademix') {
          if (Array.isArray(trimmedValues[key])) {
            trimmedValues[key].forEach((val, idx) => {
              formData.append(`${key}[${idx}]`, val);
            });
          } else {
            formData.append(key, trimmedValues[key]);
          }
        }
      });

      formData.append("assessment_id", subId);
      formData.append("student_id", parseInt(subSubId));
      formData.append("rid", studentSubmissionDetails?.attempted_id);
      formData.append("tab", attemptId ? "Attempt" : "Question Feedback");

      if (values.lecturer_Signature == null) {
        formData.delete("lecturer_Signature");
        formData.delete("signature_ip");
        formData.delete("signature_date");
        formData.delete("signature_type");
      }

      formData.delete("type");
      formData.delete("location");
      formData.delete("is_marker_signature_required");
      addUpdateFeedback(formData)
        .then(res => {
          Swal.fire({
            title: "Success",
            text: "Data updated successfully",
            icon: "success",
            confirmButtonText: "OK"
          });
          fetchData("scoreUpdate");
          fetchQuestions("scoreUpdate");
          setScoreChanged(true);
          formik.setFieldValue("type", "")
          if (values.type == "SaveChange") {
            Swal.hideLoading();
            history.push(values?.location);
          }
        })
        .catch(err => {
          console.error(err);
          if (values.type == "SaveChange") {
            Swal.hideLoading();
            Swal.fire({
              title: "Error",
              text: "Something went wrong",
              icon: "error",
              confirmButtonText: "OK"
            });
          } else {
            Swal.fire({
              title: "Error",
              text: "Something went wrong",
              icon: "error",
              confirmButtonText: "OK"
            });
          }
        })
        .finally(() => {
          setSaveLoading(false);
        });
    },
  });

  const formikStatus = useFormik({
    enableReinitialize: true,
    initialValues: {
      Status: "",
      File: "",
      isFileDeleted: 0,
      fileName:"",
      filesUpdated: false,
      submissionFiles: [],
    },
    validationSchema: Yup.object({
      Status: Yup.string().required("Status is required"),
      fileName: Yup.string().when(['Status', 'submissionFiles'], {
        is: (Status, submissionFiles) => {
          const hasFiles = submissionFiles.length > 0;
          return Status !== "open" && !hasFiles;
        },
        then: Yup.string().required("File is required"),
        otherwise: Yup.string().notRequired(),
      })
    }),
    onSubmit: async (values) => {
      setDisabled(true);
      const formData = new FormData();

      try {
        if (String(values?.Status).toLowerCase() === "final") {
          if (values.filesUpdated) {
            if (deletedSubmissionFile.deleted) {
              await DeleteAssessmentSubmissionUpload({
                intake: id,
                type: deletedSubmissionFile.file[0]?.type,
                submited_type: deletedSubmissionFile.file[0]?.submited_type,
                submission_id: deletedSubmissionFile.file[0]?.id,
              });
            }

            const awsFileUpload = [];
            const fileSize = [];
            const filePath = `Students/${studentSubmissionDetails?.student_id}_${studentSubmissionDetails?.student_number}_${studentSubmissionDetails?.first_name}_${studentSubmissionDetails?.last_name}_${subId}_${studentSubmissionDetails?.name}/${studentSubmissionDetails?.name}_${studentSubmissionDetails?.student_number}_${new Date().getTime()}_${Math.random().toString(36).slice(2, 7)}.${file.name?.split(".").pop()}`;

            awsFileUpload.push({
              file_type: file?.type,
              file_name: filePath,
            });
            fileSize.push(file?.size);

            const uploadedData = await handleUploadToS3BucketUrl(awsFileUpload, file);

            if (!uploadedData) throw new Error("Upload failed");

            uploadedData.forEach((d, i) => {
              formData.append(`document_url`, d.path);
              formData.append(`fileSize`, fileSize[i]);
            });
          }
        }

        formData.set("submission_id", studentSubmissionDetails?.submission_id);
        formData.set("status", values.Status);
        formData.set("isFileDeleted", values.Status.toString().toLowerCase() === "open" ? 1 : 0);

        await UpdateSubmission(formData);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated successfully",
        });
        setDisabled(false);
        if (attachmentRef.current) {
          attachmentRef.current.value = "";
        }
        setReload(Date.now);
      } catch (err) {
        console.error("Submission Error:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.message || "Something went wrong",
        });
        setDisabled(false);
      }
    }
  });

  useEffect(() => {
    if (formikStatus.values.Status?.toString().toLowerCase() === "open") {
      formikStatus.setFieldValue("File", "");
      formikStatus.setFieldValue("filesUpdated", false);
      formikStatus.setFieldValue("fileName","" );
      formikStatus.setFieldValue("submissionFiles", []);

      setFile("");
      setFileName("");
      if (attachmentRef.current) {
        attachmentRef.current.value = ""; // clear input ref
      }
    }
  }, [formikStatus.values.Status]);

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setDebouncedTerm(value);
  };

  const resetFilter = () => {
    setType({ arr: [], checkObj: {} });
    setLevel({ arr: [], checkObj: {} });
    setDebouncedTerm("");
    setSearch("");
  };

  const fetchData = (type) => {
    if (type != "scoreUpdate") {
      setLoading(true);
    }

    GetStudentSubmissionDetails(subId, subSubId, id, attemptId)
      .then((res) => {
        setStudentSubmissionDetails(res?.data?.data)
        setfeedbackUploadedFrom(res?.data?.data?.getAdminSignature?.generateFeedbackUploadFrom ?? 0)
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        if (type != "scoreUpdate") {
          setLoading(false);
        }
      })
  }

  const tableBottomButton = [
    {
      id : 1,
      title: "Save",
      icon: saveLoading ? "cog fa-spin" : "save",
      type: "submit",
      disabled: ((setToFinalLoading || saveLoading || loading || generateEvaluationLoading) || quizQuestions?.length < 1) ? true : false
    },
    {
      id : 2,
      title: "Generate Evaluation",
      icon: generateEvaluationLoading ? "cog fa-spin" : "clipboard-check",
      onClick: () => handleGenerateEvaluation(),
      disabled: ((setToFinalLoading || saveLoading || loading || generateEvaluationLoading || (studentSubmissionDetails?.is_marker_signature_required ? (signatureFormik.values?.lecturer_Signature == "" || !allQuestionsMarked) : !allQuestionsMarked)) || quizQuestions?.length < 1) ? true : false
    },
    {
      id : 4,
      title: "Cancel",
      icon: "times",
      className: "btn-danger",
      onClick: () => handleCancel(),
      disabled: (setToFinalLoading || saveLoading || loading || generateEvaluationLoading) ? true : false
    }
  ]


  const handleDownloadSubmissionFiles = () => {
    var zip = new JSZip();
    var zipVal = {};
    const data = [...submissionFiles];
    if (Array.isArray(data) && data.length) {
      setLoading(true);
      let myPromise = Promise.all(data.map(async (row, index) => {
        if (row.path && row.path != null && row.path != "") {
          const fileExt = row.path.split("/").reverse()[0];

          const fileURL = row?.path.startsWith("https://")
            ? row?.path
          : downloadURL +
            `${row?.path.includes("s3.af-south-1.amazonaws.com")
              ? ""
              : STUDENT_FILE_DOWNLOAD + "/"
            }${encodeURI(
              row?.path
                .replaceAll("/home/myaie/public_html/", "")
                .replace("public/", "")
            )}`;
        
          try {
            const resp = await axios({
              url: fileURL,
              method: 'get',
              responseType: 'blob'
            });

            zip.file(`${fileExt}`, resp.data, { binary: true })
          } catch (err) {
            console.log(err);
          }
        }
        zipVal = zip;
      }));
      myPromise.then(() => {
        zipVal.generateAsync({ type: "blob" })
          .then(function (content) {
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            saveAs(content, `${assessmentData.name}_submission_files_` + ".zip");
          }).catch((errr) => { console.log(errr) });
      })
    }
  }

  const handleDeleteFile = () => {
    setFile("")
    setFileName("")
    formikStatus.setFieldValue("File", "");
    formikStatus.setFieldValue("filesUpdated",false)
    formikStatus.setFieldValue("fileName","")     

    // Reseting input ref
    if (attachmentRef.current) {
      attachmentRef.current.value = "";
    }
  };

  const fetchQuestions = useCallback(async (type) => {
    if (type !== "scoreUpdate") {
      setQuestionLoading(true);
    }

    try {
      const data = {
        rid: attemptId ? parseInt(attemptId) : studentSubmissionDetails?.attempted_id,
        uid: parseInt(subSubId),
        isEvidence: 1,
        intake: id
      }

      const res = await LongAndShortAns(data);

      if (res.status === 200) {
        // Batch related state updates together
        const updates = {
          filterData: {
            type: res?.data?.questionTypeFilters,
            level: res?.data?.questionLevelFilter,
          },
          studentDetails: res?.data?.user[0],
          quizQuestions: res?.data?.dataAns?.map((item, ind) => ({
            ...item,
            finalResult: res?.data?.scoreArray[ind],
            totalScoreIndividual: res?.data?.total_score_individual[ind]
          })),
          assDetails: res?.data?.assDetails
        };

        // Update all states in one render cycle
        setFilterData(updates.filterData);
        setStudentDetails(updates.studentDetails);
        setQuizQuestions(updates.quizQuestions);
        setAssDetails(updates.assDetails);
        setAssessmentName(updates?.assDetails?.name)
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error('Error fetching questions:', error);
        // Optionally show error to user
        Swal.fire({
          title: "Error",
          text: "Failed to fetch questions. Please try again.",
          icon: "error"
        });
      }
    } finally {
      if (type !== "scoreUpdate") {
        setQuestionLoading(false);
      } else {
        setGearLoading(false);
        setScoreGear("");
        setUpdatedValue("");
      }
    }
  }, [attemptId, studentSubmissionDetails?.attempted_id, subSubId]);

  useEffect(() => {
    setAllQuestionsMarked(quizQuestions.every(question => {
      if (question?.questionType == "Document Upload" ||
        question?.questionType == "Long Answer" ||
        question?.questionType == "Evidence Only") {
        return question?.showValue == 1;
      }
      return true;
    }));
  }, [quizQuestions])

  useEffect(() => {
    const applyRowStyles = () => {
      const rows = document.querySelectorAll('.rdt_TableRow');
      rows.forEach((row, index) => {
        if (!groupedQuestions[index]?.isGroupHeader) {
          row.className = `rdt_TableRow ${groupedQuestions[index]?.className || ''}`;
        }
      });
    };

    const timer = setTimeout(applyRowStyles, 100);

    return () => clearTimeout(timer);
  }, [groupedQuestions]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = () => {
      const data = new FormData();
      data.append("user_id", studentSubmissionDetails?.submission_id);
      data.append("assessment_id", subId);
      data.append("submission_id", studentSubmissionDetails?.submission_id);
      data.append("intake", id);
      GetAssessmentSubmissionUpload(data)
        .then((res) => {
          let tempStatusArr = [];
          setFile(res.data.document_url);
          setAssessmentData(res.data?.assignments);
          setFileName(res.data.document_url && res.data.document_url.replaceAll("public/", "").replaceAll("home/myaie/public_html/", ""));
          formikStatus.setFieldValue("Status", res.data.status);
          formikStatus.setFieldValue("filesUpdated", false);
          formikStatus.setFieldValue("submissionFiles", res?.data?.submissionFiles);
          formikStatus.setFieldValue("File", "")
          formikStatus.setFieldValue("fileName","" );
          setDeletedSubmissionFile({deleted: false})
          setGetSubmissionData(res.data)
          setStatusSelected(res.data.status);
          let sttArr = res?.data?.status_arr;
          Object.keys(sttArr).map((key, index) => {
            tempStatusArr.push({ value: key, label: sttArr[key], key: key });
          });
          setStatusArr(tempStatusArr);
        })
        .catch((error) => {
          console.log("error getAssessment: ", error);
        });
    }

    if (studentSubmissionDetails?.quiz_id == 0 && studentSubmissionDetails?.submission_id) {
      fetchData();
    }
  }, [studentSubmissionDetails,reload]);

  useEffect(() => {
    if ((studentSubmissionDetails?.attempted_id || attemptId) && !scoreChanged) {
      fetchQuestions();
    }
  }, [studentSubmissionDetails, attemptId]);

  useEffect(() => {
    if (studentSubmissionDetails?.getAdminSignature) {
      setAdminData(studentSubmissionDetails?.getAdminSignature);
      formik.setFieldValue("feedback", studentSubmissionDetails?.getAdminSignature?.feedback || "");
      formik.setFieldValue("use_generated_feedback", studentSubmissionDetails?.getAdminSignature?.use_generated_feedback || 0);
      setFeedbackFiles(studentSubmissionDetails?.getAdminSignature?.additional_feedback || "");
      setFeedbackFileName(studentSubmissionDetails?.getAdminSignature?.additional_feedback || "");
      setEvaluationGenerated({
        fileName: studentSubmissionDetails?.getAdminSignature?.generated_feedback,
        fileSize: studentSubmissionDetails?.getAdminSignature?.generated_feedback_size
      });

      setIs_Signature(readOnly ? false : studentSubmissionDetails?.getAdminSignature?.signature ? true : false);
      setIpAddress(studentSubmissionDetails?.getAdminSignature?.signature_ip || null);
      setCDate(studentSubmissionDetails?.getAdminSignature?.signature_date ? studentSubmissionDetails?.getAdminSignature?.signature_date : null);
    }

    signatureFormik.setFieldValue("is_marker_signature_required", studentSubmissionDetails?.is_marker_signature_required || 0);
  }, [studentSubmissionDetails]);

  useEffect(() => {
    const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
    return () => {
      clearTimeout(timer);
    }
  }, [debouncedTerm])

  const handleFeedBack = async (e) => {
    setUploadFeedBackLoading(true)
    const file = e.target.files?.[0];
    if (!file) return;

    const filePath = `Students/${studentSubmissionDetails?.student_id}_${studentSubmissionDetails?.student_number}_${studentSubmissionDetails?.first_name}_${studentSubmissionDetails?.last_name}_${subId}_${studentSubmissionDetails?.name}/${studentSubmissionDetails?.name}_${studentSubmissionDetails?.student_number}_${moment().unix()}.${file?.name?.split(".")?.[1]}`;
  
    const uploadPayload = [{
      file_name: filePath,
      file_type: file.type,
    }];
  
    const result = await handleUploadToS3BucketUrl(uploadPayload, file);
    if (!result?.length) return;
  
    const formData = new FormData();
    const uploaded = result[0];

    formData.append("fileSizeInBytes", uploaded?.size);
    formData.append("additional_feedback", uploaded?.path);
    formData.append("assessment_id", subId);
    formData.append("student_id", parseInt(subSubId));
    formData.append("rid", studentSubmissionDetails?.attempted_id);
    formData.append("tab", attemptId ? "Attempt" : "Question Feedback");
  
    updateAdditionalFeedBack(formData)
    .then(res=>{
      if (res.status == 200) {
        console.log(res.data.data?.additional_feedback,'res.data.data?.additional_feedback')
        setFeedbackFiles(res.data.data?.additional_feedback);
        setFeedbackFileName(res.data.data?.additional_feedback);
        setAdminData(res.data.data)
      }
    })
    .catch(err =>{
      Swal.fire({
            title: "Error",
            text: "Something went wrong",
            icon: "error",
            confirmButtonText: "OK",
            timer: 3000,
          });
    }).finally(() => {
      setUploadFeedBackLoading(false);
    })
    setUploadInputKey(Date.now());
  };
  
  const handleDeleteFeedback = async () => {
    const formData = new FormData();
    formData.append("id", adminData?.id);
    formData.append("assessment_id", subId);
    formData.append("student_id", parseInt(subSubId));
    formData.append("rid", studentSubmissionDetails?.attempted_id);
    formData.append("tab", attemptId ? "Attempt" : "Question Feedback");

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const res = await deleteFeedbackFiles(formData);
        if (res.status === 200) {
          setFeedbackFiles("");
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "OK",
          timer: 3000,
        });
      }
    }
  };


  const attachmentColumns =  [
      {
        name: "Attachment",
        selector: "attachment",
        sortable: false,
        cell: (row) => {
          const fileName = row?.path?.split("/").pop() || "-";
          let fileUrl = "#";

          if (row?.path?.startsWith("https://")) {
            fileUrl = row.path;
          } else if (row?.fileUploadedFrom === "1") {
            fileUrl = AWS_BASE_URL + row?.path;
          } else {
            const cleanedPath = encodeURI(
              row?.path
                ?.replaceAll("/home/myaie/public_html/", "")
                ?.replace("public/", "")
            );
            fileUrl = `${downloadURL}${STUDENT_FILE_DOWNLOAD.replace("http:", "https:")}/${cleanedPath}`;
          }

          return (
            <a
              className="as-text-blue curser feature-name"
              href={fileUrl}
              target="_blank"
              title={fileName}
              download={"submission"}
            >
              {TrimText(fileName,60)}
            </a>
          );
        },
      },
      {
        name: "Action",
        selector: "",
        cell: (row) => (
          <div className="assessment-08 btn-dropdown-grp">
            <div className="as-buttons">
              <PermissionsGate scopes={["gamodifysub"]} errorProps={{ disabled: true }}>
                <button
                  className="btn btn-danger rounded-circle"
                  title="Delete"
                  type ="button"
                  onClick={() => handleDeleteSubmissionFile(row)}
                >
                  <i className="fal fa-trash-alt"></i>
                </button>
              </PermissionsGate>
            </div>
          </div>
        ),
      },
    ];

  const attachmentDataToRender = () => {
    const allData = formikStatus.values.submissionFiles || [];

    if (attachmentSearch?.length) {
      return allData.filter((item) => {
        const fileName = item.path?.split("/").pop()?.toLowerCase();
        return fileName?.includes(attachmentSearch.toLowerCase());
      });
    }

    return allData;
  };

  const handleDeleteSubmissionFile = (file) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText:
        "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteAssessmentSubmissionUpload({ intake: id, type: file?.type, submited_type: file?.submited_type, submission_id:file?.id}).then(res => {
          Swal.fire(
            "Deleted!",
            "File has been deleted.",
            "success"
          );
          setReload(Date.now())
          if(formikStatus.values.submissionFiles?.length === 2){
            $("#submissionModal").modal("hide");
          }
        }).catch(err => {
          console.error("error :", err)
          Swal.fire(
            "Not Deleted!",
            "File not deleted.",
            "error"
          );
        })
      }
    })
  }
  const isFormUnchanged = useMemo(() => {
    const getFileIds = (files = []) => files.map(f => f.id).sort();

    const originalIds = getFileIds(getSubmissionData?.submissionFiles);
    const currentIds = getFileIds(formikStatus.values.submissionFiles);

    const isSameFiles = JSON.stringify(originalIds) === JSON.stringify(currentIds);
    const isSameStatus = getSubmissionData?.status?.toLowerCase() === formikStatus.values?.Status?.toLowerCase();
    const isNoNewFile = String(formikStatus.values.File) === "";
    return isSameFiles && isSameStatus && isNoNewFile;
  }, [
    getSubmissionData?.submissionFiles,
    getSubmissionData?.status,
    formikStatus.values.submissionFiles,
    formikStatus.values?.Status,
    formikStatus.values?.File
  ]);


  const handleFormCancel=()=>{
    if (isFormUnchanged) return;
    formikStatus.resetForm()
    attachmentRef.current.value = "";
    setReload(Date.now())
  }

  useEffect(() => {
    formikStatus.validateForm();
  }, [formikStatus.values]);


  return (
    <>
      {loading && <SkeletonTicketList />}
      {!loading ? studentSubmissionDetails?.quiz_id == 0 ?
        <div className="card card-body-inr">
          <form onSubmit={formikStatus.handleSubmit}>
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <label htmlFor="Status">Status *</label>
                <div className="">
                  <div className="form-icon-group mb-4 ">
                    <PermissionsGate scopes={['gamodifysub']} errorProps={{ isDisabled: true }}>
                      <Select
                        className={"form-control custom-select-box" + (formikStatus.errors.Status && formikStatus.touched.Status ? " is-invalid" : "")}
                        name="Status"
                        value={statusArr.filter(function (option) {
                          return option.value == formikStatus.values.Status;
                        })}
                        onChange={(value) => {
                          if (value) {
                            formikStatus.setFieldValue("Status", value.value);
                          } else {
                            formikStatus.setFieldValue("Status", "");
                          }
                        }}
                        onBlur={formikStatus.handleBlur}
                        options={statusArr}
                        maxMenuHeight={175}
                        placeholder={formikStatus.values.Status ? formikStatus.values.Status : "Select"}
                        isClearable
                      />
                    </PermissionsGate>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-3">
                <label htmlFor="UploadFile">Upload New File {formikStatus.values.Status == "open" ? "" : '*'}</label>
                <div className={`form-group atttach-file`}>
                  <label className={`${formikStatus.errors.fileName && formikStatus.touched.fileName ? "file-req is-invalid" : ""}${formikStatus.values.Status?.toString().toLowerCase() === "open" ? "disabled-upload" : ""}`}>
                    <i className="fal fa-paperclip"></i>
                    <span>Add Attachment</span>
                    <PermissionsGate scopes={['gamodifysub']} errorProps={{ disabled: true }}>
                      <input
                        ref={attachmentRef}
                        type="file"
                        id="UploadFile"
                        className={`form-control form-control-aatch-file ${formikStatus.values.Status?.toString().toLowerCase() === "open" ? "disabled-upload" : ""}`}
                        name="File"
                        disabled={formikStatus.values.Status?.toString().toLowerCase() === "open" || disabled}
                        onChange={(e) => {
                          const file = e.target.files?.[0];

                          if (file) {
                            formikStatus.setFieldValue("File", file);
                            setFile(file);
                            const objectURL = URL.createObjectURL(file);
                            setFileName(objectURL);
                            formikStatus.setFieldValue("fileName", objectURL);
                            formikStatus.setFieldValue("filesUpdated", true);
                          } else if (e.target.value === "") {
                            // Only clear if there was NO previous file set
                            if (!formikStatus.values.File && !formikStatus.values.submissionFiles?.length) {
                              formikStatus.setFieldValue("File", "");
                              formikStatus.setFieldValue("filesUpdated", false);
                              formikStatus.setFieldValue("fileName", "");
                              setFile(null);
                              setFileName(null);
                            }

                            if (attachmentRef.current) {
                              attachmentRef.current.value = "";
                            }
                          }
                        }}

                      />
                    </PermissionsGate>
                  </label>
                </div>

                <div className="frm-group">
                  <ul className="list-unstyled attached-file-ul m-0 submission-file">
                    {formikStatus.values.submissionFiles.length > 0 ? (
                      <div className='pt-0 mb-2 mt-2'>
                        {formikStatus.values.submissionFiles.length === 1 ? (
                          <li className='pt-0 mb-2 mt-1'> 
                              <a
                                className="as-text-blue curser file-link"
                                title="View Submission"
                                href={
                                  formikStatus.values.submissionFiles[0]?.path?.startsWith('https://')
                                    ? formikStatus.values.submissionFiles[0].path
                                    : formikStatus.values.submissionFiles[0]?.fileUploadedFrom === '1'
                                      ? AWS_BASE_URL + formikStatus.values.submissionFiles[0].path
                                      : `${downloadURL}${STUDENT_FILE_DOWNLOAD.replace("http:", "https:")}/${encodeURI(
                                        formikStatus.values.submissionFiles[0].path
                                          ?.replaceAll("/home/myaie/public_html/", "")
                                          ?.replace("public/", "")
                                      )}`
                                }
                                target="_blank"
                              >
                                <i className="fal fa-file pr-1"></i> 
                                {formikStatus.values.submissionFiles[0]?.path?.split('/').pop()}
                              </a>
                            <button
                              className="btn btn-danger position-static transform-none"
                              type='button'
                              title="Delete"
                              disabled={disabled || loading}
                              onClick={() => {
                                if (formikStatus.values.submissionFiles?.length > 1) {
                                  handleDeleteSubmissionFile(formikStatus.values.submissionFiles[0])
                                }else{
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You won't be able to revert this!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText:
                                      "Yes, delete it!",
                                  }).then((result)=>{
                                   if (!result.isConfirmed) return
                                   const files = formikStatus.values.submissionFiles;
                                    if (files?.length == 1) {
                                      formikStatus.setFieldValue("submissionFiles", []);
                                      formikStatus.setFieldValue("filesUpdated", true);
                                    }
                                    setDeletedSubmissionFile({ file: formikStatus.values.submissionFiles, deleted: true });
                                  })
                                }
                              }
                              }
                            >
                              <i className="fal fa-trash-alt"></i>
                            </button>
                          </li>
                        ) : (
                          <span
                            className="as-text-blue curser"
                            title="View Submission"
                            data-toggle="modal"
                            data-target="#submissionModal"
                          >
                            <i className="fal fa-file pr-1"></i>
                            View Submission
                          </span>
                        )}
                      </div>
                    ): null}
                    {fileName?.includes("blob") && (
                      <li className='pt-0 mb-2 mt-1'>
                        <a className="as-text-blue curser file-link" href={fileName?.includes("blob") ? fileName : `${downloadURL}${STUDENT_FILE_DOWNLOAD}/${encodeURI(fileName)}`} target={"_blank"}>
                          <i className="fal fa-file pr-1"></i>
                          {fileName?.includes("blob") ? file.name : fileName.split("/").reverse()[0]}
                        </a>
                        <PermissionsGate scopes={["gamodifysub"]} errorProps={{ disabled: true }}>
                          <button className="btn btn-danger position-static transform-none" disabled={disabled || loading} onClick={()=>handleDeleteFile()} type="button">
                            <i className="fal fa-trash-alt"></i>
                          </button>
                        </PermissionsGate>
                      </li>
                    )}
                  </ul>
                </div>

              </div>
            </div>
            <div className="form-group form-group-save-cancel">
              <PermissionsGate scopes={['gamodifysub']} errorProps={{ disabled: true }}>
                <button className="btn btn-save btn-success" disabled={loading || disabled || isFormUnchanged} type="submit" title="Save">
                  {disabled ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
                  Save
                </button>
              </PermissionsGate>
              <button className="btn btn-close btn-danger" disabled={disabled} type="button" title="Cancel" 
                onClick={() => handleFormCancel()}>
                <i className="fal fa-times"></i>
                Cancel
              </button>
              {formikStatus.touched.fileName && formikStatus.errors.fileName ? <div className="invalid-feedback d-block">{formikStatus.errors.fileName}</div> : null}
              {formikStatus.touched.Status && formikStatus.errors.Status ? <div className="invalid-feedback d-block">{formikStatus.errors.Status}</div> : null}
            </div>
          </form>
        </div> :
        <AssessmentDetails 
        assessmentHeader={studentSubmissionDetails} 
        isSubmissionAndResult={true} 
        studentDetails={studentDetails}
        /> : null
      }

      {!loading ? studentSubmissionDetails?.quiz_id == 0 ? null : <>
        <div className="my-tickets-info-list Tickets-main-wrap">
          <div className="custom-table-div filter-search-icon card card-table-custom program-table">
            <div className="search-filter-div">
              <div className="search-filter-div-left">
                <div className="system-administration-table table-responsive">
                  <div className="table-responsive-div">
                    <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                      <div id="assessment-table-main_filter" className="dataTables_filter">
                        <label>
                          <input
                            type="search"
                            className=""
                            placeholder="Search"
                            aria-controls="assessment-table-main"
                            onChange={handleSearchFilter}
                            value={debouncedTerm}
                          />
                        </label>
                        <div className="filter-eff filter-data-btn">
                          <button className="filter-buttons">
                            <i className="fal fa-filter"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="filter-button-group">
                    <div className="filter-scroll">
                      <div className={`filter-scroll-inner filter-custom-new`}>
                        <Tablefilter
                          filterName="Type"
                          optionArr={filterData?.type}
                          state={type}
                          setState={setType}
                          renderLabelFunction={RenderQuestionType}
                        />
                      </div>
                    </div>
                    <div className="filter-scroll">
                      <div className={`filter-scroll-inner filter-custom-new`}>
                        <Tablefilter
                          filterName="Level"
                          optionArr={filterData?.level}
                          state={level}
                          setState={setLevel}
                          renderLabelFunction={RenderQuestionLevel}
                        />
                      </div>
                    </div>
                    <div className="reset-btn-group">
                      <div className="button-reset dropdown-comman">
                        <button
                          className="btn btn-primary"
                          onClick={resetFilter}
                          title="Reset"
                        >
                          <i className="fal fa-redo"></i>Reset
                        </button>
                      </div>
                      <div className="files-export-group">
                        <button
                          type="button"
                          className="btn btn-files"
                          onClick={() => {
                            exportData("xlsx", "Assessment Questions List");
                          }}
                          title="Export spreadsheet"
                        >
                          <i className="fal fa-file-excel icon"></i>
                        </button>
                        <button
                          type="button"
                          className="btn btn-files"
                          onClick={() => {
                            exportData("csv", "Assessment Questions List");
                          }}
                          title="Export CSV"
                        >
                          <i className="fal fa-file-csv icon"></i>
                        </button>
                        <button
                          type="button"
                          className="btn btn-files"
                          onClick={() => {
                            exportData("pdf", "Assessment Questions List");
                          }}
                          title="Export PDF"
                        >
                          <i className="fal fa-file-pdf icon"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <DataTable
              progressPending={questionLoading}
              data={groupedQuestions}
              progressComponent={<SkeletonTicketList />}
              columns={columns}
              pagination={false}
              highlightOnHover={false}
            />


            <div title="Feedback" className='font-weight-bold mb-3 mt-4' ><i className="fas fa-file-user user__icon"></i> Feedback</div>

            <form onSubmit={(e) => {
              e.preventDefault();
              handleSubmit()
            }}>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group-blk mb-3" title="Remarks">
                    <label htmlFor="feedback">Remarks <i className="fal fa-info-circle"></i></label>
                    <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
                      <input
                        type="text"
                        className={`form-control ${formik.errors.feedback && formik.touched.feedback ? "is-invalid" : ""}`}
                        placeholder="Notes or remarks to student"
                        name="feedback"
                        id="feedback"
                        value={formik.values.feedback}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </PermissionsGate>
                  </div>
                </div>

                <div className={`col-md-4 col-lg-2 mb-1`}>
                  <div className={`form-group-blk mb-3`} title={"Upload Additional Feedback"}>
                    <label htmlFor="lecturer_feedback_files">
                      Upload Additional Feedback
                    </label>

                    <div className="form-group atttach-file m-0">
                      <label>
                        {uploadFeedBackLoading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-upload"></i>}
                        <span>Upload</span>

                        <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
                          <input
                            key={uploadInputKey}
                            type="file"
                            disabled={uploadFeedBackLoading}
                            className="form-control form-control-aatch-file"
                            onChange={(e) => handleFeedBack(e)}
                            name="lecturer_feedback_files"
                            id="lecturer_feedback_files"
                          />
                        </PermissionsGate>
                      </label>
                    </div>
                  </div>

                  {feedbackFiles && (
                    <>
                      <div className="frm-group">
                        <ul className="list-unstyled attached-file-ul m-0">

                          <li>
                            <a
                              href={
                                feedbackFileName && feedbackFileName.includes("blob")
                                  ? feedbackFileName
                                  : typeof feedbackFiles === "string"
                                    ? feedbackFiles.startsWith("https://")
                                      ? feedbackFiles
                                      : adminData?.feedbackUploadedFrom ? AWS_BASE_URL + feedbackFiles: `${IMAGE_URL}/${feedbackFiles.replace("public/", "")}`
                                        .replaceAll("public/", "")
                                        .replaceAll("home/myaie/public_html/", "")
                                    : feedbackFiles?.file?.startsWith("https://")
                                      ? feedbackFiles.file
                                      : `${IMAGE_URL}/${feedbackFiles?.file ? feedbackFiles.file : feedbackFiles?.path}`
                                        .replaceAll("public/", "")
                                        .replaceAll("home/myaie/public_html/", "")
                              }                        
                              title={feedbackFiles?.name ? feedbackFiles?.name : typeof feedbackFiles === "string" ? getFileName(feedbackFiles) : getFileName(feedbackFiles?.path)}
                              target="_blank"
                            >
                              <i className="fal fa-file"></i>
                              &nbsp;
                              {feedbackFiles?.name
                                ? TrimText(feedbackFiles?.name, 40)
                                : TrimText(
                                  typeof feedbackFiles === "string"
                                    ? getFileName(feedbackFiles)
                                    : feedbackFiles?.path
                                      ? getFileName(feedbackFiles.path)
                                      : "",
                                  40
                                )
                              }
                            </a>
                            <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
                              <button
                                type="button"
                                className="btn btn-danger rounded-circle btn-dropdown-item"
                                title="Delete"
                                onClick={() => handleDeleteFeedback()}
                              >
                                <i className="fal fa-trash-alt"></i>
                              </button>
                            </PermissionsGate>
                          </li>
                        </ul>
                      </div>
                    </>
                  )}
                </div>

                {evaluationGenerated?.fileName ? <>
                  <div className="col-md-4 col-lg-2">
                    <div className="form-group-blk mb-3">
                      <label htmlFor="generated_evaluation" title="View Generated Feedback">View Generated Feedback</label>
                      <div className="form-group atttach-file m-0" title="Generated Evaluation">
                        {RenderAttachList({
                          feedbackUploadedFrom: feedbackUploadedFrom,
                          fileName: evaluationGenerated?.fileName?.substring(evaluationGenerated?.fileName?.lastIndexOf("/") + 1),
                          size: formatFileSize(parseInt(evaluationGenerated?.fileSize || "0")),
                          filePath: `${evaluationGenerated?.fileName?.includes("https://")
                              ? evaluationGenerated.fileName
                              : `${feedbackUploadedFrom ? AWS_BASE_URL : (IMAGE_URL+"/")}${evaluationGenerated?.fileName?.replace("public/", "")}`
                            }`,
                          showClose: false,
                        })}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 col-lg-2" style={{ marginTop: 32 }}>
                    <div className="form-group-blk" title="Use Generated Evaluation">
                      <div className="">
                        <div className="custom-check-group">
                          <div
                            className="custom-check custom-control custom-checkbox"
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="use_generated_feedback"
                              name="use_generated_feedback"
                              checked={formik.values.use_generated_feedback == 1}
                              onChange={(e) =>
                                formik.setFieldValue(
                                  "use_generated_feedback",
                                  e.target.checked ? 1 : 0
                                )
                              }
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="use_generated_feedback"
                            >
                              <div className="mr-3"></div> Use Generated Evaluation
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </> : null}

                <div className={`${evaluationGenerated?.fileName ? "col-lg-6" : "col-lg-8"}`}></div>

                {studentSubmissionDetails?.is_marker_signature_required == 1 ? <div className="col-xl-4 col-lg-6 col-md-8">
                  <div className="form-group-blk mb-3">
                    <div className="form-group m-0">
                      <DigitalSignatureComponent isCancel={isCancel} formik={signatureFormik} signaturePadRef={signaturePadRef} fileInputRef={fileInputRef} cDate={cDate} ipAddress={ipAddress} setIpAddress={setIpAddress} setCDate={setCDate} setIsSig={setIsSig} readOnly={readOnly} readOnlyData={studentSubmissionDetails?.getAdminSignature} is_Signature={is_Signature} setIs_Signature={setIs_Signature} signature_Type={signatureFormik.values.signature_type} isSig={isSig} studentSubmissionDetails={studentSubmissionDetails} disabled={saveLoading}/>
                    </div>
                  </div>
                </div> : null}
              </div>

              <div className='form-group form-group-save-cancel mt-4'>
                {
                  tableBottomButton?.map((button, index) => {
                    return (
                      <PermissionsGate scopes={studentSubmissionDetails?.isHybrid ? ["cassgradeassedit"] : ["overidersmart"]} errorProps={{ disabled: true }}>
                        <button
                          key={button?.id}
                          type={button?.type ? button?.type : "button"}
                          className={`btn ${button?.className ? button?.className : 'btn-primary'}`}
                          title={button.title}
                          onClick={button.onClick}
                          disabled={button?.disabled}
                        >
                          <i className={`fal fa-${button?.icon}`}></i> {button?.title}
                        </button>
                      </PermissionsGate>
                    )
                  })
                }
              </div>

              {Object.keys(formik.errors).map((key) => {
                if (formik.touched[key]) {
                  return (
                    <div className="invalid-feedback d-block mt-2" key={key}>
                      {formik.errors[key]}
                    </div>
                  );
                }
                return null;
              })}

              {errorMessage ? <div className="invalid-feedback d-block mt-2" key="errorMessage">{errorMessage}</div> : null}

              {signatureFormik?.touched?.lecturer_Signature && signatureFormik?.errors?.lecturer_Signature ? (
                <div className="invalid-feedback d-block">
                  {signatureFormik.errors.lecturer_Signature}
                </div>
              ) : null}
            </form>
          </div>
        </div> 

        <SubmissionModal
          studentDetails={studentDetails}
          assDetails={assDetails}
          selectedStudentDetails={selectedStudentDetails}
          setSelectedStudentDetails={setSelectedStudentDetails}
          handleDownload={() => handleDownload(selectedStudentDetails?.qid, `${studentDetails?.studentName}_${assessmentName}`)}
          handleRefresh={() => { 
            setRefreshStudentList(!refreshStudentList)
            fetchQuestions()
          }}
          isMatchingQuestionType={isMatchingQuestionType}
          questionData={selectedStudentDetails}
          assessmentHeader={studentSubmissionDetails}
          tabName={attemptId ? "Attempt" : "Question Feedback"}
          downloadRef={downloadRef}
        />

       
      </> : null}


        {/* submision model */}
        <div
          className="topic-add-modal modal fade"
          id="submissionModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered available-attachments-modal"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header modal-header-custom">
                <h5 className="modal-title">
                  <i className="fal fa-file"></i> Submission
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {loading ? (
                  <SkeletonTicketList />
                ) : (
                  <DataTableComponentFrontPagination
                    data={attachmentDataToRender()}
                    columns={attachmentColumns}
                    loading={loading}
                    isExport={false}
                    search={attachmentSearch}
                    setSearch={setAttachmentSearch}
                    exportFileName={"Attachment List"}
                    isInsidePopUp
                    isActionAlignRight
                    defaultSort={{
                      defaultSortColumn: "attachment",
                      defaultSortAsc: true,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
    </div>
    </>
  )
}

export default SubmissionAndResultForm;
